import { Component, Input, OnInit } from '@angular/core';
import { AlertService, JhiLanguageService, EventManager } from 'ng-jhipster';
import { NgbDateStruct, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';

import { Student, StudentService, StudentUtilService } from '../../entities/student';
import { CountryService } from '../../entities/country';
import { CityService } from '../../entities/city';
import { SchoolService } from '../../entities/school';
import { Principal, AccountService, JhiLanguageHelper } from '../../shared';
import { StateStorageService } from '../../shared/auth/state-storage.service';
import { AbstractGeograpicalDialogComponent } from '../../entities/abstract-dialog-component/abstract-geopraphical-dialog.component';
import { TaxService } from '../../entities/tax';

@Component({
    selector: 'jhi-settings',
    templateUrl: './settings.component.html'
})
export class SettingsComponent extends AbstractGeograpicalDialogComponent implements OnInit {
    error: string;
    success: string;
    settingsAccount: any;
    student: Student;
    languages: any[];
    currencyCode: string = 'EUR'; // Euro ISO 4217 code

    readonly minDate: NgbDateStruct;

    constructor(
        private account: AccountService,
        alertService: AlertService,
        countryService: CountryService,
        cityService: CityService,
        taxService: TaxService,
        private studentService: StudentService,
        private studentUtilService: StudentUtilService,
        principal: Principal,
        private languageService: JhiLanguageService,
        private languageHelper: JhiLanguageHelper,
        private eventManager: EventManager,
        private stateStorageService: StateStorageService,
        schoolService: SchoolService
    ) {
        super(countryService, cityService, taxService, schoolService, alertService, principal);
        this.minDate = { year: 1940, month: 1, day: 1 };
        this.languageService.setLocations(['settings', 'student', 'user-management']);
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.settingsAccount = this.copyAccount(account);
            this.loadStudent(account.id);
            this.success = null;
        });
        this.languageHelper.getAll().then((languages) => {
            this.languages = languages;
        });
    }

    public onSelectChange(event: NgbTabChangeEvent) {
        this.success = null;
    }

    loadStudent(userId: number) {
        this.studentService.getCurrent()
        .subscribe(
            (student: Student) => {
                this.student = student;

                // Remove the currency symbol if there is no active product
                // TODO: Remove once totalPaid and total reflects always amounts
                if (!this.student.status.activeProduct) {
                    this.currencyCode = '';
                }

                if (this.student.dateOfBirth) {
                    this.student.dateOfBirth = {
                        year: this.student.dateOfBirth.getFullYear(),
                        month: this.student.dateOfBirth.getMonth() + 1,
                        day: this.student.dateOfBirth.getDate()
                    };
                }

                this.loadGeographicalLocations(this.student != null ? this.student.countryId : null);
            }
        );
    }

    saveAccount() {
        this.account.save(this.settingsAccount).subscribe(() => {
            this.error = null;
            this.success = 'OK';
            this.principal.identity(true).then((account) => {
                this.settingsAccount = this.copyAccount(account);
                this.stateStorageService.setAccountLabel(account.firstName);

                this.eventManager.broadcast({ name: 'accountModification', content: account.firstName});
            });
            this.languageService.getCurrent().then((current) => {
                if (this.settingsAccount.langKey !== current) {
                    this.languageService.changeLanguage(this.settingsAccount.langKey);
                }
            });
        }, () => {
            this.success = null;
            this.error = 'ERROR';
        });
    }

    saveStudent() {
        return this.studentService.updateCurrent(this.student)
            .subscribe({
                next: () => {
                    this.error = null;
                    this.success = 'OK';
                },
                error: () => {
                    this.success = null;
                    this.error = 'ERROR';
                }
            });
    }

    copyAccount(account) {
        return {
            activated: account.activated,
            email: account.email,
            firstName: account.firstName,
            langKey: account.langKey,
            lastName: account.lastName,
            login: account.login,
            imageUrl: account.imageUrl
        };
    }

    getStatusBadgeStyle(percentage: number): string {
        return this.studentUtilService.getStatusBadgeStyle(percentage);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/settings/settings.component.ts